module.exports = __webpack_public_path__ + "img/spin.48a61003.png";